module.exports = __webpack_public_path__ + "media/images/h4-b29c6eed8bb72576eb9aea6964566dea.svg";